/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Directive, TemplateRef} from '@angular/core';
export class WizardPageNavTitleDirective {
/**
 * @param {?} pageNavTitleTemplateRef
 */
constructor(public pageNavTitleTemplateRef: TemplateRef<any>) {}
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clrPageNavTitle]"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
];
}

function WizardPageNavTitleDirective_tsickle_Closure_declarations() {
/** @type {?} */
WizardPageNavTitleDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WizardPageNavTitleDirective.ctorParameters;
/** @type {?} */
WizardPageNavTitleDirective.prototype.pageNavTitleTemplateRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
